import { z } from 'zod/v4';

import { VIDEO_GENERATION_MODEL_OPTIONS } from './constants';

const videoGenerationFormSchema = z.object({
    prompt: z.string().trim().min(1, 'Prompt is required'),
});

export type SelectedLibraryImage = {
    thumbnailUrl: string;
    contentId: number;
    title: string;
};

export type VideoGenerationFormState = z.infer<typeof videoGenerationFormSchema> & {
    aspectRatio: string;
    model: string;
    duration: string;
    resolution: string;
    file: File | null;
    /** Set when `file` is a toolkit-generated image ("Generate as video"), so the video records it as its parent. */
    sourceAiContentId: string | null;
    selectedLibraryImage: SelectedLibraryImage | null;
    validationActive: boolean;
};

export type VideoGenerationFormErrors = Partial<
    Record<keyof z.infer<typeof videoGenerationFormSchema> | 'file', string>
>;

export const VIDEO_GENERATION_FORM_DEFAULTS: VideoGenerationFormState = {
    prompt: '',
    aspectRatio: '16:9',
    model: VIDEO_GENERATION_MODEL_OPTIONS[0].value,
    duration: '4',
    resolution: '720p',
    file: null,
    sourceAiContentId: null,
    selectedLibraryImage: null,
    validationActive: false,
};

export function validateVideoGenerationForm(state: VideoGenerationFormState): {
    isValid: boolean;
    errors: VideoGenerationFormErrors;
} {
    const result = videoGenerationFormSchema.safeParse(state);
    if (result.success) {
        return { isValid: true, errors: {} };
    }

    const errors: VideoGenerationFormErrors = {};
    for (const issue of result.error.issues) {
        const field = issue.path[0];
        if (typeof field === 'string' && field in VIDEO_GENERATION_FORM_DEFAULTS) {
            errors[field as keyof VideoGenerationFormErrors] = issue.message;
        }
    }
    return { isValid: false, errors };
}
